import moment from 'moment'
import _ from 'lodash'

export default dateField

/** @ngInject */
function dateField() {
    return ({
        restrict: 'E',
        template: require('./date-field.jade')(),
        scope: {
            date: '=',
            min: '=',
            max: '=',
        },
        link($scope) {
            const now = moment($scope.date)
            $scope.dateObj = {
                day: now.date(),
                month: now.month() + 1,
                year: now.year(),
            }
            $scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
            $scope.months = [
                { label: 'janvier', value: 1 },
                { label: 'février', value: 2 },
                { label: 'mars', value: 3 },
                { label: 'avril', value: 4 },
                { label: 'mai', value: 5 },
                { label: 'juin', value: 6 },
                { label: 'juillet', value: 7 },
                { label: 'août', value: 8 },
                { label: 'septembre', value: 9 },
                { label: 'octobre', value: 10 },
                { label: 'novembre', value: 11 },
                { label: 'décembre', value: 12 },
            ]
            const year = moment().year()
            const minYear = $scope.min ? moment($scope.min).year() : year
            const maxYear = $scope.max ? moment($scope.max).year() : year + 1
            $scope.years = _.range(minYear, maxYear + 1)

            $scope.checkDate = () => {
                if ($scope.dateObj.day && $scope.dateObj.month && $scope.dateObj.year) {
                    let date = moment(`${$scope.dateObj.year}-${$scope.dateObj.month}-${$scope.dateObj.day}`, 'YYYY-M-D')
                    while (!date.isValid()) {
                        $scope.dateObj.day -= 1
                        date = moment(`${$scope.dateObj.year}-${$scope.dateObj.month}-${$scope.dateObj.day}`, 'YYYY-M-D')
                    }
                    $scope.date = date
                    return true
                }
                return false
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/date-field/date-field.js